import { Flex, Form } from "antd";
import { useMemo } from "react";

import {
    ScheduleFiltersPanel,
    ScheduleFiltersPanelValues,
} from "@/domains/route";

import { RouteScheduleListBlock } from "../blocks/RouteScheduleListBlock";
import { MyRouteCapabilities } from "../MyRoute.policy";
import { MyRouteData } from "../MyRoute.types";

interface RouteListSectionProps {
    capabilities: MyRouteCapabilities;
    points: MyRouteData["points"];
    schedules: MyRouteData["schedules"];
}

export const RouteListSection = ({
    capabilities,
    points,
    schedules,
}: RouteListSectionProps) => {
    const [filtersForm] = Form.useForm<ScheduleFiltersPanelValues>();
    const search = Form.useWatch("search", filtersForm);
    const day = Form.useWatch("day", filtersForm);

    const filteredSchedules = useMemo(() => {
        const normalizedSearch = search?.trim().toLowerCase();
        const selectedDay = Number(day || 0);

        return schedules.filter((schedule) => {
            const point = points[schedule.pointId];

            if (!point) return false;

            const matchesSearch =
                !normalizedSearch ||
                point.market.building.address?.name
                    ?.toLowerCase()
                    .includes(normalizedSearch) ||
                point.market.contragent?.name
                    ?.toLowerCase()
                    .includes(normalizedSearch);

            const matchesDay =
                selectedDay === 0 || schedule?.days?.includes(selectedDay);

            return matchesSearch && matchesDay;
        });
    }, [day, points, schedules, search]);

    return (
        <Flex vertical gap={16}>
            <ScheduleFiltersPanel form={filtersForm} />

            <RouteScheduleListBlock
                capabilities={capabilities}
                points={points}
                schedules={filteredSchedules}
            />
        </Flex>
    );
};
